import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, KeyRound } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/PasswordInput";
import { toast } from "sonner";

export default function ChangePassword() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) { toast.error("Les mots de passe ne correspondent pas"); return; }
    if (pwd.length < 6) { toast.error("Minimum 6 caractères"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { new_password: pwd });
      await refresh();
      toast.success("Mot de passe mis à jour");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur");
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <div className="rounded-2xl border border-[var(--border-soft)] bg-white p-8 shadow-[var(--shadow-sm)]">
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-[var(--surface-2)]">
          <KeyRound className="h-6 w-6 text-[var(--shariti-orange)]" />
        </div>
        <h1 className="text-xl font-extrabold tracking-tight">Changer mon mot de passe</h1>
        <p className="mt-1 text-sm text-muted-ink">Choisissez un nouveau mot de passe personnel.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label className="text-xs font-semibold">Nouveau mot de passe</Label>
            <PasswordInput value={pwd} onChange={(e) => setPwd(e.target.value)} className="mt-1.5" inputClassName="h-11" data-testid="newpwd-1" />
          </div>
          <div>
            <Label className="text-xs font-semibold">Confirmer</Label>
            <PasswordInput value={pwd2} onChange={(e) => setPwd2(e.target.value)} className="mt-1.5" inputClassName="h-11" data-testid="newpwd-2" />
          </div>
          <Button type="submit" disabled={loading} className="h-11 w-full bg-[var(--shariti-orange)] text-white hover:bg-[#E56622]" data-testid="newpwd-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Enregistrer"}
          </Button>
        </form>
      </div>
    </div>
  );
}
